<template>
  <rect x="3" y="3.00293" width="10" height="2" rx="1" />
  <rect x="3" y="7.00293" width="10" height="2" rx="1" />
  <rect x="3" y="11.0029" width="10" height="2" rx="1" />
</template>
